
import {Circle, Fill, Icon, Stroke, Style, Text} from 'ol/style';

import { Log } from '../../core';
const log = Log.getLogger('MultiSceneForApp.openlayers.olStyles');

function createFill(color) {
    return new Fill({
        color
    });
}

function createStroke(color, width) {
    return new Stroke({
        color,
        width
    });
}

function createLineBasicStyle(strokeColor, strokeWidth, styleItems) {
    return new Style({
        stroke: createStroke(strokeColor, strokeWidth),
        ...styleItems
    });
}

function createPolygonBasicStyle(strokeColor, strokeWidth, fillColor, styleItems) {
    return new Style({
        stroke: createStroke(strokeColor, strokeWidth),
        fill: createFill(fillColor),
        ...styleItems
    });
}

function createCircle(radius, strokeColor, strokeWidth, fillColor, styleItems) {
    return new Circle({
        radius,
        stroke: createStroke(strokeColor, strokeWidth),
        fill: createFill(fillColor),
        ...styleItems
    });
}

function createIcon(src, styleItems) {
    return new Style({
        image: new Icon({
            src: src,
            ...styleItems
          })
    });
}

function createPointCircle(radius, strokeColor, strokeWidth, fillColor, styleItems) {
    return new Style({
       image: createCircle(radius, strokeColor, strokeWidth, fillColor),
       ...styleItems
    });
}

function createPointRegularShape(radius, points, angle, strokeColor, strokeWidth, fillColor, styleItems) {
    return new Style({
       image: createRegularShape(radius, points, angle, strokeColor, strokeWidth, fillColor),
       ...styleItems
    });
}

function createPointSquare(radius, strokeColor, strokeWidth, fillColor, styleItems) {
    return new Style({
       image: createRegularShape(radius, 4, Math.PI / 4, strokeColor, strokeWidth, fillColor),
       ...styleItems
    });
}

function createRegularShape(radius, points, angle, strokeColor, strokeWidth, fillColor, styleItems) {
    return new RegularShape({
        radius,
        points,
        angle,
        stroke: createStroke(strokeColor, strokeWidth),
        fill: createFill(fillColor),
        ...styleItems
    });
}

function createStyleCircle(styleDefinition) {
    return createPointCircle(
        styleDefinition.radius,
        styleDefinition.outlineColor,
        styleDefinition.width,
        styleDefinition.color,
        {}
    );
}

function createStyleLine(styleDefinition) {
    let styles = [];
    if (styleDefinition.outlineColor) {
        styles.push(
            createLineBasicStyle(
                styleDefinition.outlineColor, styleDefinition.width + 2, {}
            )
        );
    }
    styles.push(
        createLineBasicStyle(
            styleDefinition.color, styleDefinition.width, {}
        )
    );
    return styles;
}

function createStylePointIcon(styleDefinition) {
    return createIcon(
        styleDefinition.src,
        styleDefinition
    );
}

function createStylePointTransparent(styleDefinition) {
    return createPointCircle(
        5, 'rgba(0, 0, 0, 0)', 1, 'rgba(0, 0, 0, 0)', {}
    );
}

function createStylePolygon(styleDefinition) {
    return createPolygonBasicStyle(
        styleDefinition.outlineColor, styleDefinition.width, styleDefinition.color, {}
    );
}

function createStyle(styleDefinition) {
    switch (styleDefinition.type) {
        case 'circle':
            return createStyleCircle(styleDefinition);
        case 'icon':
            return createStylePointIcon(styleDefinition);
        case 'line':
            return createStyleLine(styleDefinition);
        case 'pointTransparent':
            return createStylePointTransparent(styleDefinition);
        case 'polygon':
            return createStylePolygon(styleDefinition);
        default:
            log.warn(`unknown style definition type: "${styleDefinition.type}`);
            return null;
    }
}

function createStyles(stylesDefinition) {
    return stylesDefinition.map(item => {
        return createStyle(item);
    });
}

export {
    createCircle,
    createFill,
    createIcon,
    createLineBasicStyle,
    createPointCircle,
    createPointRegularShape,
    createPointSquare,
    createPolygonBasicStyle,
    createRegularShape,
    createStyle,
    createStyles,
    createStroke
}
